import React from "react";
import { useSelector, useDispatch } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { FiX } from "react-icons/fi";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

// import createCategory from "../../../Assets/create-category.gif";
// import createProduct from "../../../Assets/create-product.gif";
// import createLink from "../../../Assets/create-link.gif";
// import createQuestion from "../../../Assets/create-question.gif";

import videos from "./videos.json";
import { setHelpDialogState } from "../../../Store/Modules/Dialogs/Actions";
import MyDialog from "../../../Theme/Dialog";

import { Title, Container, ImageContent } from "./styles";

function HelpDialog() {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(null);
  const { helpDialog } = useSelector((state) => state.dialogs);

  function handleClose() {
    dispatch(setHelpDialogState("show", false));
    dispatch(setHelpDialogState("data", {}));
  }

  return (
    <Dialog fullScreen onClose={handleClose} open={helpDialog.show}>
      <DialogTitle>
        <Title>Ajuda do Mindi</Title>
        <IconButton
          style={{ position: "absolute", right: "40px", top: "0px" }}
          onClick={() =>
            window.open("https://api.whatsapp.com/send?phone=+553498807793")
          }
        >
          <WhatsAppIcon fontSize="large" />
        </IconButton>
        <Button
          style={{ position: "absolute", right: "10px", top: "10px" }}
          onClick={handleClose}
        >
          <FiX style={{ fontSize: "25px" }} />
        </Button>
      </DialogTitle>
      <DialogContent>
        <Container>
          {videos.map((video) => (
            <>
              <Button
                fullWidth
                variant="outlined"
                color="default"
                onClick={() => setOpen(video.youtubeId)}
              >
                {video.title}
              </Button>
              <MyDialog
                title={video.title}
                fullScreen
                onClose={() => setOpen(null)}
                open={open === video.youtubeId}
              >
                <ImageContent>
                  <iframe
                    width="100%"
                    src={"https://www.youtube.com/embed/" + video.youtubeId}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </ImageContent>
              </MyDialog>
            </>
          ))}
        </Container>
      </DialogContent>
    </Dialog>
  );
}

export default HelpDialog;
